import * as React from 'react';
import { Avatar, Chip, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { VirtualProviderPlayerDto } from '../../models/dtos/VirtualProviderCatalogDto';
import VirtualPlayerSkills from './VirtualPlayerSkills';

export default function VirtualPlayersTable(props: {
    players: VirtualProviderPlayerDto[];
    sportNames: Map<number, string>;
    onPlayerClick?: (player: VirtualProviderPlayerDto) => void;
}) {
    if (props.players.length === 0) return <Typography color="text.secondary">No players found.</Typography>;

    return <TableContainer>
        <Table size="small">
            <TableHead><TableRow>
                <TableCell>Player</TableCell><TableCell>Sport</TableCell><TableCell>Origin</TableCell><TableCell align="center">Skills</TableCell>
                <TableCell>Current team</TableCell><TableCell>Created</TableCell>
            </TableRow></TableHead>
            <TableBody>{props.players.map(player => {
                const membership = player.memberships.find(item => item.effective);
                return <TableRow
                    key={player.id}
                    hover
                    onClick={() => props.onPlayerClick?.(player)}
                    onKeyDown={event => {
                        if (props.onPlayerClick && (event.key === 'Enter' || event.key === ' ')) {
                            event.preventDefault();
                            props.onPlayerClick(player);
                        }
                    }}
                    tabIndex={props.onPlayerClick ? 0 : undefined}
                    sx={props.onPlayerClick ? { cursor: 'pointer' } : undefined}
                >
                    <TableCell><Stack direction="row" spacing={1.5} alignItems="center">
                        <Avatar src={player.imageUrl ?? undefined} sx={{ width: 32, height: 32 }}>{player.name.slice(0, 1)}</Avatar>
                        <span><Typography variant="body2">{player.name}</Typography><Typography variant="caption" color="text.secondary">{player.nameRu || player.id}</Typography></span>
                    </Stack></TableCell>
                    <TableCell>{player.sportId == null ? '—' : props.sportNames.get(player.sportId) ?? `Sport ${player.sportId}`}</TableCell>
                    <TableCell>{player.originCountry} · {player.yearOfBirth}</TableCell>
                    <TableCell align="center"><VirtualPlayerSkills player={player} /></TableCell>
                    <TableCell>{membership ? <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body2">{membership.team.name}</Typography>
                        <Chip size="small" label={membership.lineupType.replace(/_/g, ' ')} />
                    </Stack> : <Typography variant="body2" color="text.secondary">Unassigned</Typography>}</TableCell>
                    <TableCell>{new Date(player.createdAt).toLocaleString()}</TableCell>
                </TableRow>;
            })}</TableBody>
        </Table>
    </TableContainer>;
}
